// src/components/GameButton.tsx
import React from 'react';

interface GameButtonProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const GameButton: React.FC<GameButtonProps> = ({ label, onClick, type = "button", disabled = false }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: 'rgba(61, 185, 69, 0.3)',
        color: 'rgba(236, 232, 232, 1)',
        padding: '0.7rem 1.6rem',
        borderRadius: '20px',
        border: '2px solid rgba(236, 232, 232, 1)',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        textAlign: 'center',
        display: 'inline-block', // ✅ wrap to content size
        opacity: disabled ? 0.6 : 1,
        transition: 'background-color 0.2s ease',
      }}
    >
      {label}
    </button>
  );
};

export default GameButton;